// @ts-nocheck
import React, { useState } from 'react';
import { ChevronDownIcon } from './icons';

/**
 * Accordion — list of disclosable items. Pass `items` as `[{ title, content }]`.
 * Multiple may be open at once unless `singleOpen` is set.
 */
const Accordion = ({ items = [], singleOpen = false, defaultOpen = [], className = '' }) => {
  const [open, setOpen] = useState(new Set(defaultOpen));
  const toggle = (i) => {
    setOpen((prev) => {
      const next = new Set(prev);
      if (next.has(i)) next.delete(i);
      else if (singleOpen) { next.clear(); next.add(i); }
      else next.add(i);
      return next;
    });
  };
  return (
    <div className={['flex flex-col gap-2', className].join(' ')}>
      {items.map((it, i) => {
        const isOpen = open.has(i);
        return (
          <div
            // eslint-disable-next-line react/no-array-index-key
            key={i}
            style={{
              background: 'var(--mov-paper)',
              border: '1px solid var(--mov-line)',
              borderRadius: 12,
              overflow: 'hidden',
            }}
          >
            <button
              type="button"
              onClick={() => toggle(i)}
              aria-expanded={isOpen}
              className="w-full flex items-center justify-between gap-3 text-left cursor-pointer"
              style={{
                padding: '14px 16px',
                background: 'transparent',
                border: 0,
                color: 'var(--mov-ink)',
                fontWeight: 500,
                fontSize: 14,
              }}
            >
              <span>{it.title}</span>
              <ChevronDownIcon
                size={16}
                className="text-mov-ink-mute transition-transform"
                style={{ transform: isOpen ? 'rotate(180deg)' : 'none' }}
              />
            </button>
            {isOpen && (
              <div
                style={{
                  padding: '0 16px 14px',
                  fontSize: 13,
                  lineHeight: 1.55,
                  color: 'var(--mov-ink-soft)',
                }}
              >
                {it.content}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default Accordion;
